import { render, staticRenderFns } from "./RingSharing.vue?vue&type=template&id=583e2f98&scoped=true&"
import script from "./RingSharing.vue?vue&type=script&lang=ts&"
export * from "./RingSharing.vue?vue&type=script&lang=ts&"
import style0 from "./RingSharing.vue?vue&type=style&index=0&id=583e2f98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583e2f98",
  null
  
)

export default component.exports